import React, {Component} from 'react';
import {Upload, Modal, message} from 'antd';

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export class WeiboPicturesWall extends Component {

    listShow = this.props.listShow;

    state = {
        previewVisible: false,
        previewImage: '',
        fileList: this.props.fileList
    };

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({fileList:nextProps.fileList})
    }

    componentDidMount()
    {

    }

    handleCancel = () => this.setState({ previewVisible: false });

    handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }

        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
        });
    };

    handleChange = ({ fileList }) => {
        this.setState({ fileList });
    };

    render() {
        const { previewVisible, previewImage, fileList } = this.state;
        return (
            <div className="clearfix">
                <Upload
                    showUploadList={{showRemoveIcon:this.props.isShowRemoveBtn}}
                    action="/cm-sites-pms/ueditor/control?action=uploadimage"
                    listType="picture-card"
                    fileList={fileList}
                    data={{dataSource:7}}
                    onPreview={this.handlePreview}
                    onRemove={this.props.handleRemove}
                />
                <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}
                       width={600} bodyStyle={{height:600}}
                >
                    <table cellSpacing={0} cellPadding={0} border={0} width={"100%"} height={"100%"}><tbody>
                        <tr>
                            <td align={"center"} valign={"middle"}><img style={{maxWidth:552,maxHeight:552}} alt="example" src={previewImage} /></td>
                        </tr>
                    </tbody></table>
                </Modal>
            </div>
        );
    }
}
WeiboPicturesWall.defaultProps = {
    isShowRemoveBtn: true
};